import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';

import { commonStyles } from '../../styles/styles';

const RenderCheckbox = ({ classes, checkedStatus, input }) => (
  <FormControlLabel
    control={
      <Checkbox
        checked={checkedStatus}
        {...input}
        value={`"false"`}
        classes={{
          root: classes.root,
          checked: classes.checked,
        }}
      />
    }
    label="I'm a team leader"
  />
);

const styles = () => ({
  ...commonStyles,
  checked: {
    color: '#50E3C2',
  },
  label: {
    color: '#4A4A4A',
  },
  root: {
    color: '#A0A0A0',
    '&$checked': {
      color: '#50E3C2',
    },
  },
});

export default compose(withStyles(styles))(RenderCheckbox);



// WEBPACK FOOTER //
// ./src/Components/Form/AmLeader.jsx